// Autogenerated file
export const organizationFlagsEnum = {
    CanCreateBids: "CanCreateBids",
    NoAccessToEditBooks: "NoAccessToEditBooks",
    HasCompoundCargos: "HasCompoundCargos",
    AnalyzeOverallReportByHourlyMileage: "AnalyzeOverallReportByHourlyMileage",
    AdminHasAccessToDriverPasswords: "AdminHasAccessToDriverPasswords",
    UseCargorunRouterOnly: "UseCargorunRouterOnly",
    ParallelItemChangePoints: "ParallelItemChangePoints",
    AdminCanDownloadDriverList: "AdminCanDownloadDriverList",
    IsDocumentReceivingMandatory: "IsDocumentReceivingMandatory",
    AutoSetMainContract: "AutoSetMainContract",
    DisplayLateAndIdleTimeInReport: "DisplayLateAndIdleTimeInReport",
    AllowUnloadPointAdjustmentUsage: "AllowUnloadPointAdjustmentUsage",
    HeadLogistCanEditCompletedBids: "HeadLogistCanEditCompletedBids",
    ProhibitionOfStartingBidIfEmptyStarted: "ProhibitionOfStartingBidIfEmptyStarted",
    LimitedFunctionality: "LimitedFunctionality",
    SuitableOrders: "SuitableOrders",
    BidPlanMarginality: "BidPlanMarginality",
    TrackEmptyMileageBidTypes: "TrackEmptyMileageBidTypes",
    ProhibitionOfRevertingBidForHeadLogist: "ProhibitionOfRevertingBidForHeadLogist",
    HiddenDirection: "HiddenDirection",
    SkipBlockIfUnpaid: "SkipBlockIfUnpaid",
    ProhibitionOfBidDelete: "ProhibitionOfBidDelete",
    UseOdometerMileage: "UseOdometerMileage",
    UpdateStartedByWhenCarChanged: "UpdateStartedByWhenCarChanged",
    AllowEditingCompletedBidsForEnterprise: "AllowEditingCompletedBidsForEnterprise",
    UseRefuelingTransactions: "UseRefuelingTransactions",
    UseTrailerMileage: "UseTrailerMileage",
    ForceCompleteOnLastPointManualDates: "ForceCompleteOnLastPointManualDates",
};
export const organizationFlags = [
    { label: "Может создавать заявки", value: "CanCreateBids", intValue: 1 },
    { label: "Нет доступа к справочникам", value: "NoAccessToEditBooks", intValue: 2 },
    { label: "Может создавать сборные заявки", value: "HasCompoundCargos", intValue: 4 },
    { label: "Анализ по часовым пробегам в общем отчете", value: "AnalyzeOverallReportByHourlyMileage", intValue: 8 },
    { label: "Доступ к паролям водителей", value: "AdminHasAccessToDriverPasswords", intValue: 16 },
    { label: "Использовать только навигацию CARGO.RUN в МП Водители", value: "UseCargorunRouterOnly", intValue: 32 },
    { label: "Параллельные перецепки", value: "ParallelItemChangePoints", intValue: 64 },
    { label: "Администратор может скачивать список водителей", value: "AdminCanDownloadDriverList", intValue: 128 },
    { label: "Обязательность отметки сдачи документов", value: "IsDocumentReceivingMandatory", intValue: 256 },
    { label: "Автоматически заполнять договор при выборе контрагента", value: "AutoSetMainContract", intValue: 512 },
    { label: "Отображать отчет по загрузке выгрузке с временем опоздания и простоя", value: "DisplayLateAndIdleTimeInReport", intValue: 1024 },
    { label: "Доступ к модулю \"Автоматическое определение точки выгрузки\" из заявки", value: "AllowUnloadPointAdjustmentUsage", intValue: 2048 },
    { label: "Главный логист может редактировать завершенные заявки", value: "HeadLogistCanEditCompletedBids", intValue: 4096 },
    { label: "Запрет запуска заявки в работу если запущена порожняя", value: "ProhibitionOfStartingBidIfEmptyStarted", intValue: 8192 },
    { label: "Ограниченный функционал", value: "LimitedFunctionality", intValue: 16384 },
    { label: "Подходящие заказы", value: "SuitableOrders", intValue: 65536 },
    { label: "Плановая маржинальность заявки", value: "BidPlanMarginality", intValue: 131072 },
    { label: "Отслеживать типы порожних заявок", value: "TrackEmptyMileageBidTypes", intValue: 262144 },
    { label: "Запрет возврата заявок в черновик для главного логиста", value: "ProhibitionOfRevertingBidForHeadLogist", intValue: 524288 },
    { label: "Скрытое направление", value: "HiddenDirection", intValue: 1048576 },
    { label: "Не блокировать компанию автоматически при неуплате", value: "SkipBlockIfUnpaid", intValue: 2097152 },
    { label: "Запрет удаления заявок пользователями", value: "ProhibitionOfBidDelete", intValue: 4194304 },
    { label: "Использовать пробег по одометру", value: "UseOdometerMileage", intValue: 8388608 },
    { label: "Обновлять инициатора заявки при изменении ТС", value: "UpdateStartedByWhenCarChanged", intValue: 16777216 },
    { label: "Редактирование выполненных заявок без ограничений через 1С", value: "AllowEditingCompletedBidsForEnterprise", intValue: 33554432 },
    { label: "Учет транзакций в отчетах по АЗС", value: "UseRefuelingTransactions", intValue: 67108864 },
    { label: "Использовать пробег по прицепу", value: "UseTrailerMileage", intValue: 134217728 },
    { label: "При указании ручных дат на последней точке открывать форму ручного закрытия заявки", value: "ForceCompleteOnLastPointManualDates", intValue: 268435456 },
];
